import React from 'react';
import { NavigationRoute, useNavigation, useRouterPath } from 'shared-utils';
import Breadcrumb from 'components/Breadcrumb';
import { DashboardNavigation, BioTypeNavigation } from 'screens/routes';

type Props = {
    label: string;
};

const BioTypeBreadcrumb: React.FC<Props> = ({ label }: Props) => {
    const homePath = useRouterPath(DashboardNavigation());
    const bioTypePath = useRouterPath(BioTypeNavigation());
    const { push: navigate } = useNavigation();

    const triggerNav = React.useCallback((route: NavigationRoute) => (event: React.MouseEvent<any>) => {
        if (event.ctrlKey || event.metaKey) return;

        event.preventDefault();
        navigate(route);
    }, [navigate]);

    return (
        <Breadcrumb>
            <Breadcrumb.Home
                key="bc-home"
                to={homePath ?? undefined}
                onClick={triggerNav(DashboardNavigation())}
            />
            <Breadcrumb.Item
                key="bc-bioType"
                to={bioTypePath ?? undefined}
                onClick={triggerNav(BioTypeNavigation())}
            >
                Types de protection
            </Breadcrumb.Item>
            <Breadcrumb.Item key="bc-bioType-details">{label}</Breadcrumb.Item>
        </Breadcrumb>
    );
};

export default BioTypeBreadcrumb;
